import {
  DEFAULT_WAYPOINT_TEXTURE_SIZE,
  useSvg,
  WaypointFlashScanSelected,
  WaypointSelected,
} from "@faro-lotv/app-component-toolbox";
import { Texture } from "three";

const colorsToReplace = {
  "#1F65F0": "red",
};

type WaypointsSelectedTextures = {
  selectedTexture: Texture | undefined;
  selectedFlashScanTexture: Texture | undefined;
};

/** @returns the textures to use when the waypoints get selected */
export function useWaypointsSelectedTextures(): WaypointsSelectedTextures {
  const selectedTexture = useSvg(WaypointSelected, {
    width: DEFAULT_WAYPOINT_TEXTURE_SIZE,
    height: DEFAULT_WAYPOINT_TEXTURE_SIZE,
    generateMipmaps: true,
    colorsToReplace,
  });

  const selectedFlashScanTexture = useSvg(WaypointFlashScanSelected, {
    width: DEFAULT_WAYPOINT_TEXTURE_SIZE,
    height: DEFAULT_WAYPOINT_TEXTURE_SIZE,
    generateMipmaps: true,
    colorsToReplace,
  });

  return { selectedTexture, selectedFlashScanTexture };
}
